<ng-container class='container'>
  <icc-list [items]="mountings" (select)="selectMounting($event)" [selected]="mountingId" [itemTemplate]="'itemImgTitle'" itemImgHeight="medium"></icc-list>
</ng-container>
